export const TOP_BAR_HEIGHT = 56
export const SIDE_BAR_WIDTH = 60
/** Vendor nav: icons + under-labels; narrower than the previous 100px trial. */
export const VENDOR_SIDE_BAR_WIDTH = 90

export const getSidebarWidth = (companyType?: string): number =>
    companyType === 'VENDOR' ? VENDOR_SIDE_BAR_WIDTH : SIDE_BAR_WIDTH

export const temp = {}
export const AGENT_DRAWER_WIDTH = 350
export const AGENT_HEADER_WIDTH = 136
export const WALKTHROUGH_PANEL_HEIGHT = 360
export const AGENT_CHANNEL_WIDTH = 50
export const LORI_CHANNEL_HEADER_HEIGHT = 50
export const LORI_CHANNEL_INPUT_HEIGHT = 130
export const CONTACT_SUPPORT_URL = 'https://form.jotform.com/220725897018159'
